angular.module('shared').factory('ConfirmBulkMessageService', ["$rootScope", "$q", "$modal", "$http", "SmsValidationService", function($rootScope, $q, $modal, $http, SmsValidationService) {
  return {
    confirm: function(bulkMessage, gym) {
      var count, deferred, modalInstance, recipients, showWarning, singleCount;
      deferred = $q.defer();
      singleCount = SmsValidationService.getMessagesCount(bulkMessage.template.content);
      recipients = bulkMessage.recipientList.filter(function(recipient) {
        return recipient.selected;
      }).length;
      count = singleCount * recipients;
      showWarning = gym.has_subscription && gym.charges_for_sms && gym.bulk_sms_warning_threshold > 0 && gym.per_sms_cost_cents > 0 && bulkMessage.template.channel === 'sms' && count >= gym.bulk_sms_warning_threshold;
      if (showWarning) {
        modalInstance = $modal.open({
          template: require('templates/gyms/bulk_messages/large_message_count_warning.html.slim'),
          resolve: {
            count: function() {
              return count;
            },
            fee: function() {
              return gym.per_sms_cost_cents / 100;
            },
            currency: function() {
              return gym.billing_currency_symbol;
            },
            freeSmsThreshold: function() {
              return gym.free_sms_threshold;
            },
            smsPartsSentThisMonth: function() {
              var url;
              url = `/gyms/${gym.id}/sent_messages/smses_parts_this_month`;
              return $http.get(url).then(function(response) {
                return response.data.sms_parts_sent_this_month;
              });
            }
          },
          controller: ["$scope", "$rootScope", "$modalInstance", "count", "fee", "currency", "freeSmsThreshold", "smsPartsSentThisMonth", function($scope, $rootScope, $modalInstance, count, fee, currency, freeSmsThreshold, smsPartsSentThisMonth) {
            var freeBalance, logWarning;
            gym = $rootScope.gym;
            $scope.count = count;
            $scope.fee = fee;
            $scope.currency = currency;
            $scope.freeSmsThreshold = freeSmsThreshold;
            $scope.month = moment().format('MMMM');
            freeBalance = (freeSmsThreshold - smsPartsSentThisMonth) * fee;
            $scope.freeBalance = freeBalance >= 0 ? freeBalance : 0;
            logWarning = function() {
              var url;
              url = `gyms/${gym.id}/sent_messages/log_excess_sms_warning`;
              return $http.post(url);
            };
            logWarning();
            $scope.submit = function() {
              return $modalInstance.close();
            };
            return $scope.cancel = function() {
              return $modalInstance.dismiss('cancel');
            };
          }]
        });
        modalInstance.result.then(function() {
          return deferred.resolve();
        });
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    }
  };
}]);
